/** The ONDO mark: four bars of unequal weight, drawn on a 40×40 grid. */
export function OndoMark({ title }: { title?: string }) {
  return (
    <svg viewBox="0 0 40 40" fill="none" role={title ? "img" : "presentation"}>
      {title && <title>{title}</title>}
      <rect x="1" y="4" width="5" height="32" fill="currentColor" />
      <rect x="9" y="4" width="14" height="32" fill="currentColor" />
      <rect x="27" y="4" width="5" height="32" fill="currentColor" />
      <rect x="35" y="4" width="5" height="32" fill="currentColor" />
    </svg>
  );
}
